import { createFileRoute } from '@tanstack/react-router'
import SelectionListContainer from 'SelectionList/containers/SelectionListContainer'
import { claimTypesEnum } from 'User/utils/claims'

import { Guard } from '../-guard'

export const Route = createFileRoute('/contacts/list/$id')({
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_contacts]}>
            <SelectionListContainer />
        </Guard>
    ),
})
